import { axiosClient } from "@/lib/axios";
import { HttpError } from "@/types/error";
import { PublicSession } from "@classview/shared-types";
import { UseMutationOptions, useMutation } from "@tanstack/react-query";

const enableChat = async ({
  sessionId,
}: {
  sessionId: string;
}): Promise<PublicSession> => {
  const response = await axiosClient.post(
    `/sessions/${sessionId}/in-call/enable-chat`,
  );
  return response.data;
};

function useEnableChat(
  mutationOptions?: Partial<
    UseMutationOptions<PublicSession, HttpError, { sessionId: string }>
  >,
) {
  return useMutation({
    mutationFn: ({ sessionId }) => enableChat({ sessionId }),
    ...mutationOptions,
  });
}

const disableChat = async ({
  sessionId,
}: {
  sessionId: string;
}): Promise<PublicSession> => {
  const response = await axiosClient.post(
    `/sessions/${sessionId}/in-call/disable-chat`,
  );
  return response.data;
};

function useDisableChat(
  mutationOptions?: Partial<
    UseMutationOptions<PublicSession, HttpError, { sessionId: string }>
  >,
) {
  return useMutation({
    mutationFn: ({ sessionId }) => disableChat({ sessionId }),
    ...mutationOptions,
  });
}

export { useDisableChat, useEnableChat };
